import { HttpMethod } from '@previo/core'
import Http from '~/http/Http'
import { APIPaths } from '~/http/APIPaths'

export type PlaceSuggestion = {
  label: string
}

export type PlaceSuggestionsResponse = PlaceSuggestion[]

export class PlacesAPI extends Http {
  autocomplete = (input: string): Promise<PlaceSuggestionsResponse> => {
    return this.callAuthAPI<null, PlaceSuggestionsResponse>(
      HttpMethod.GET,
      { path: APIPaths.PLACES_AUTOCOMPLETE, query: { input } },
      null,
    )
  }
}
